import { AbiService } from "./index";
import { BasicAbiService } from "./BasicAbiService";

/**
 * Пул оборачивает методы сервисов в Promise.race и вызывает их параллельно.
 * Резолвится первый успешно завершившийся вызов, остальные результаты игнорируются.
 */
export class AbiServicePool implements BasicAbiService<any> {
  abis: AbiService[] = [];

  /**
   * Добавляет abi-сервис в пул
   * @param abi
   */
  add(abi: AbiService) {
    this.abis.push(abi);
    return this;
  }

  getMintedCount(): Promise<number> {
    return Promise.any(this.abis.map((abi) => abi.getMintedCount()));
  }

  getTokenPrice(): Promise<string> {
    return Promise.any(this.abis.map((abi) => abi.getTokenPrice()));
  }

  isStarted(): Promise<boolean> {
    return Promise.any(this.abis.map((abi) => abi.isStarted()));
  }

  mint(amount: number, amountToBn: any): Promise<any> {
    return Promise.any(this.abis.map((abi) => abi.mint(amount, amountToBn)));
  }

  mintRef(amount: number, amountToBn: any, ref: string): Promise<any> {
    return Promise.any(
      this.abis.map((abi) => abi.mintRef(amount, amountToBn, ref))
    );
  }

  mintFreeOne(): Promise<any> {
    return Promise.any(this.abis.map((abi) => abi.mintFreeOne()));
  }
}
